module.exports = __webpack_public_path__ + "img/taisiev-image-box.96f1231d.jpg";